import React from 'react';
import { RadioGroup } from '@headlessui/react';
export interface OptionLabelGroupProps {
  defaultOption: number;
  optionsValue: unknown[];
  onChange: any;
  accessor: string;
  index: number;
}

function classNames(...classes: string[]) {
  return classes.filter(Boolean).join(' ');
}

const OptionsRender = ({
  optionsValue,
  onChange,
  defaultOption,
  accessor,
  index,
}: OptionLabelGroupProps) => {
  
  const selected = optionsValue.find((e:any) =>e.id === defaultOption)
  
  return (
    <RadioGroup value={selected} onChange={(e) => onChange(e)}>
      <div className={'relative -space-y-px rounded-md bg-white'}>
        {React.Children.toArray(
         optionsValue.map((el, opsIdx) => (
            <RadioGroup.Option
              // key={`horizontal-list-radio-${index}`}
              value={el}
              className={({ checked }) =>
                classNames(
                  opsIdx === 0 ? 'rounded-tl-md rounded-tr-md' : '',
                  opsIdx === optionsValue.length - 1
                    ? 'rounded-bl-md rounded-br-md'
                    : '',
                  checked
                    ? 'z-10 border-primary-200 bg-primary-50'
                    : 'border-gray-200',
                  'relative flex cursor-pointer flex-col border p-4 focus:outline-none md:grid md:grid-cols-3 md:pl-4 md:pr-6'
                )
              }
            >
              {({ active, checked }) => (
                <span className="flex items-center text-sm">
                  <span
                    className={classNames(
                      checked
                        ? 'bg-primary-600 border-transparent'
                        : 'bg-white border-gray-300',
                      active ? 'ring-2 ring-offset-2 ring-primary-600' : '',
                      'h-4 w-4 rounded-full border flex items-center justify-center'
                    )}
                    aria-hidden="true"
                  >
                    <span className="rounded-full bg-white w-1.5 h-1.5" />
                  </span>
                  <RadioGroup.Label
                    as="span"
                    className={classNames(
                      checked ? 'text-primary-900' : 'text-gray-900',
                      'ml-3 font-medium'
                    )}
                  >
                    {(el as any)?.[accessor]}
                  </RadioGroup.Label>
                </span>
              )}
            </RadioGroup.Option>
          ))
        )}
      </div>
    </RadioGroup>
  );
};
export function OptionLabelGroup(props: OptionLabelGroupProps) {
  const { optionsValue, onChange, accessor, defaultOption, index } = props;
  return (
    <OptionsRender
      defaultOption={defaultOption}
      index={index}
      accessor={accessor}
      optionsValue={optionsValue}
      onChange={onChange}
    />
  );
}

export default OptionLabelGroup;
  